/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState } from 'react'
import { Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/solid'
import { useRouter } from 'next/router'

export default function DeploymentStatusNotifications({ name, message }: { name: string, message: string }) {
  const [show, setShow] = useState(true)
  const router = useRouter();
  const { projectId, modelId } = router.query;

  return (
    <>
      <div
        aria-live="assertive"
        className="fixed inset-0 z-50 top-0 flex items-start px-4 py-6 pointer-events-none sm:p-6"
      >
        <div className="w-full flex flex-col z-50 items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={show}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="max-w-sm w-full z-50 bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
              <div className="p-4">
                <div className="flex items-start justify-between">
                  <div className="flex flex-1 items-center">
                    <div className="flex-shrink-0">

                      <svg className="animate-spin mt-1 h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-50" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-100" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>

                    </div>
                    <div className="ml-4 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">{name} is {message}...</p>
                      <button onClick={() => router.push(`/${projectId}/${modelId}/live/log`)} className="mt-1 text-sm text-blue-500 cursor-pointer">Click to see progress.</button>
                    </div>
                  </div>
                  <div className="ml-4 flex-shrink-0 flex">
                    <button
                      className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={() => {
                        setShow(false)
                      }}
                    >
                      <span className="sr-only">Close</span>
                      <XIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  )
}
